import { cn } from "../../lib/utils";

const LoadingSpinner = ({ size = "md", className }) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
    xl: "w-12 h-12",
  };

  return (
    <div
      className={cn(
        "animate-spin rounded-full border-2 border-gray-300 border-t-blue-600",
        sizeClasses[size],
        className
      )}
    />
  );
};

const LoadingPage = ({ message = "Chargement..." }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900">
      <LoadingSpinner size="xl" />
      <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg">{message}</p>
    </div>
  );
};

const LoadingOverlay = ({ isVisible, message = "Chargement..." }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 flex flex-col items-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-700 dark:text-gray-300">{message}</p>
      </div>
    </div>
  );
};

const LoadingCard = ({ className }) => {
  return (
    <div className={cn("animate-pulse", className)}>
      <div className="bg-gray-200 dark:bg-gray-700 rounded-lg h-32 w-full"></div>
    </div>
  );
};

const LoadingTable = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="animate-pulse">
      <div className="bg-gray-200 dark:bg-gray-700 h-10 rounded mb-4"></div>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex space-x-4 mb-3">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className="bg-gray-200 dark:bg-gray-700 h-8 rounded flex-1"
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
};

export {
  LoadingSpinner,
  LoadingPage,
  LoadingOverlay,
  LoadingCard,
  LoadingTable,
};

































